import React from "react";

import ProdutoFormPageContainer from "./ProdutoFormPageContainer";

export class ProdutoFormPage extends React.Component {
  render() {
    return <ProdutoFormPageContainer {...this.props} />;
  }
}
